module.exports = __webpack_public_path__ + "img/barcode.342fa38e.svg";